module.exports = __webpack_public_path__ + "static/media/dotx-icon.5e1e64ec.svg";